import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { environment } from '@env/environment';
import { DefaultLayoutComponent } from './layout/default-layout/default-layout.component';
import { LoginComponent } from './components/login/login.component';
import { UpdateUserComponent } from './components/update-user/update-user.component';
import { AuthGuard } from '@shared/auth/auth-guard';
import { AuthService } from '@shared/auth/auth.service';

// export function tokenGetter() {
//   return sessionStorage.getItem("jwt");
// }

const routes: Routes = [
  {
    path: '',
    component: DefaultLayoutComponent,
    children: [
      { path: '', redirectTo: 'login', pathMatch: 'full' },
      { path: 'login', component: LoginComponent },
      { path: 'update-user', canActivate: [AuthGuard], component: UpdateUserComponent },
      { path: 'ptUpload/:id',
        canActivate: [AuthGuard],
        loadChildren: () => import('./components/ptUpload/ptUpload.module').then(m => m.PtUploadModule)
      },
      { path: 'settings', 
        canActivate: [AuthGuard],
        loadChildren: () => import('./components/settings/orelapSettings.module').then(m => m.OrelapSettingsModule)
      },
      {
        path: 'sessions',
        loadChildren: () => import('./components/sessions/sessions.module').then(m => m.SessionsModule),
      },
      {
        path: 'lab-user-menu',
        canActivate: [AuthGuard],
        loadChildren: () => import('./components/lab-user-menu/lab-user-menu.module').then(m => m.LabUserMenuModule)
      },
      {
        path: 'application-menu',
        canActivate: [AuthGuard],
        loadChildren: () => import('./components/application-menu/application-menu.module').then(m => m.ApplicationMenuModule)
      },
      {
        path: 'reports',
        canActivate: [AuthGuard],
        loadChildren: () => import('./components/reports/reports.module').then(m => m.ReportsModule)
      },
      {
        path: 'inspection',
        canActivate: [AuthGuard],
        loadChildren: () => import('./components/inspection/inspection.module').then(m => m.InspectionModule)
      },
      {
        path: 'ptMenu',
        canActivate: [AuthGuard],
        loadChildren: () => import('./components/ptMenu/ptMenu.module').then(m => m.PtMenuModule)
      },
      {
        path: 'manageUsers',
        canActivate: [AuthGuard],
        loadChildren: () => import('./components/manageUsers/manageUsers.module').then(m => m.ManageUsersModule)
      },
   ]
  },
  { path: '**', redirectTo: 'login' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
    useHash: environment.useHash,
    enableTracing: false
    }),
  ],
  providers: [AuthGuard,AuthService],
  exports: [RouterModule],
  declarations: [],
})
export class RoutesRoutingModule {}
